/**
 * The global jQuery namespace
 * @namespace jQuery
 */

 /**
 * The global jQuery function namespace
 * @namespace jQuery.fn
 */

/**
 * An HTML DOM element.
 * @typedef {(Object)} HTMLElement
 */
 window.WS = (function($) {
	if (!$.fn.serializeObject) {
		/**
		 * @function jQuery.fn#serializeObject
		 * @description
		 * Works like jQuery#serializeArray, but retuns a key/value pair object instead.
		 */
		$.fn.serializeObject = function() {
		    var result = {}, array;

		    array = this.serializeArray();

		    $.each(array, function() {
		        if (result[this.name] !== undefined) {
		            if (!result[this.name].push) {
		                result[this.name] = [result[this.name]];
		            }

		            result[this.name].push(this.value || '');
		        } else {
		            result[this.name] = this.value || '';
		        }
		    });

		    return result;
		};
	}

	if (typeof $.WS === "undefined") {
		/**
		 * @class jQuery.WS
		 */
		$.WS = function() {
			var ws = this, modules = {}, factory = {};

			/**
			 * @function jQuery.WS.createModule
			 * @arg {String} member - Name of the Module to create
			 * @arg {Function} constructor - Constructor function, used to return a module
			 * @description
			 * Used for creating a custom Module within the jQuery.WS namespace.
			 * Modules should be executable functions which provide functionality or manipulate the
			 * jQuery managed elements passed to it in some way.
			 *
			 * When executed, The `constuctor` function is is passed the {@link jQuery} Object
			 * containing the relevant DOM elements, and is expected to return a public interface of
			 * methods defined with an object of key/value pairs.
			 * @example
			 * // defining a Revealing Object Module
			 * MyModule = function($elements) {
			 * 	var my, cls;
			 *
			 * 	my = {
			 * 		privateMethod = function() {
			 * 			my.private_property = 'foo';
			 * 		}
			 * 	};
			 *
			 * 	cls = {
			 *		setProp = function(value) {
			 *			my.private_property = value;
			 * 			$elements.data('prop', my.private_property);
		 	 *		}
		 	 *
			 *		getProp = function() {
			 *			console.log(my.private_property); // 'foo'
		 	 *		}
			 *	}
			 *
			 * 	return cls;
			 * }
			 *
			 * $.WS.createModule("myModule", MyModule);
			 * @example
			 * // initialise a Module against the elements supplied
			 * $("div").WS("myModule");
			 *
			 * // execute methods
			 * $("div").WS("myModule", "getProp"); // 'foo'
			 * $("div").WS("myModule", "setProp", "bar");
			 * $("div").WS("myModule", "getProp"); // 'bar'
			 */
			factory.createModule = function(member, constructor) {
				var instance = 0, instances = [];

				// create jquery handler wrapper for class construct
				modules[member] = function() {
					var index,
						args = arguments,
						label = "ws." + member + "-instance-index",
						result = this;

					// loop through each element in the collection and create an instance of module
					this.each(function() {
						var $this = $(this);

						// instance counter - stored or created
						if ((index = $this.data(label)) === undefined) {
							$this.data(label, instance);
							index = instance;
							instance = instance + 1;
						}

						if (typeof args[1] === "string") {
							// class method being called
							if (instances[index] && instances[index][args[1]]) {
								result = instances[index][args[1]].apply(
									this,
									Array.prototype.slice.call(args, 2)
								);
							} else {
								throw new Error("Instance must be created before methods are used");
							}
						} else if (!instances[index]) {
							// class being instantiated
							instances.push(constructor(
								this,
								Array.prototype.slice.call(args, 1)
							));
						}
					});

					// return the passed jQuery object unless instance being run
					return result;
				};
			};

			/**
			 * @namespace jQuery.fn.WS
			 */
			$.fn.WS = function(member, fn) {
				// execute/instantiate class
				if (member !== undefined &&
					typeof modules[member] === "function") {
					return modules[member].apply(this, arguments);
				} else {
					throw new Error("Module '" + member + "' could not be found within WS namespace");
				}
			};

			return {
				createModule: function() {
					// create a class
					factory.createModule.apply(ws, arguments);
				}
			};
		}();
	}

	/**
	 * The built in Number object.
	 * @external Number
	 */
	if (typeof Number.toFormatted === "undefined") {
		/**
		 * @function external:Number#toFormatted
		 * @arg {number} decimals Length of decimal precision.
		 * @arg {string} thousands_separator="," Character for separating thousand portions.
		 * @arg {string} decimal_separator="." Character for separating the decimal portion.
		 * @description
		 * Formats a number, adding thousands seperators and optional decimals.
		 */
		Number.prototype.toFormatted = function(decimals, thousands_separator, decimal_separator) {
			var num, re, dec_string, len, a,
				default_decimal_separator = ".";

			if (!decimal_separator) {
				decimal_separator = default_decimal_separator;
			}

			num = this.toString().split(default_decimal_separator);

			if (decimals) {
				dec_string = (num.length > 1) ? num[1].substring(0, decimals) : "0";
				len = dec_string.length;

				if (len < decimals) {
					for (a = 0; a < (decimals - len); a += 1) {
						dec_string += "0";
					}
				}

				num[1] = decimal_separator + dec_string;
			} else {
				num[1] = '';
			}

			if (thousands_separator !== false) {
				re = /(\d+)(\d{3})/;

				if(typeof thousands_separator != "string") {
					thousands_separator = ",";
				}

				while (re.test(num[0])) {
					num[0] = num[0].replace(re, "$1"+thousands_separator+"$2");
				}
			}

			return num[0] + num[1];
		};
	}

	/**
	 * The built in Element object.
	 * @external Element
	 */
	if (typeof Element !== "undefined") {
		if (typeof document.documentElement.click === "undefined" && document.createEvent) {
			/**
			 * @function external:Element#click
 			 * @arg {HTMLElement} [element] The affected DOM element.
			 * Simulate a DOM 'click' event on the extended element.
			**/
			Element.prototype.click = function(element) {
				var dispatch;

				dispatch = document.createEvent("MouseEvents");
				dispatch.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

				element.dispatchEvent(dispatch);
			};
		}
	}

	if (typeof window.ob_set === "undefined") {
		/**
		 * @function ob_set
		 * @arg {Object} ob The object to augment.
		 * @arg {Object} defaults The default properties to set, should they not exist within `ob`.
		 * @returns {Object} The augmented object.
		 * @global
		 * @description
		 * Augments `ob` Object with the default properties set in `default`, in the case that
		 * the property cannot be found (or is `undefined`).
		 */
		window.ob_set = function(ob, defaults) {
			// set default object properties
			var key;

			for (key in defaults) {
				if (defaults.hasOwnProperty(key)) {
					if (defaults[key] !== null && defaults[key].constructor === Object &&
						(ob[key] === undefined || ob[key].constructor === Object)) {
						// traverse nested objects
						ob[key] = window.ob_set(ob[key] || {}, defaults[key]);
					} else if (ob[key] === undefined) {
						// replace missing objects
						ob[key] = defaults[key];
					}
				}
			}

			return ob;
		};
	}

	/**
	 * The built in Function object.
	 * @external Function
	 */
	if (typeof Function.bind === "undefined") {
		/**
		 * @function external:Function.bind
		 * @arg {Object} context The new execution context.
		 * @description
		 * Control the execution context of a function with the `context` parameter.
		**/
		Function.prototype.bind = function(context) {
			var fn = this;
			return function() {
				return fn.apply(context, arguments);
			};
		};
	}

	/**
	 * Whitespace
	 * @namespace WS
	 */
	return {
		/**
		 * @namespace WS.Include
		 */
		Include: (function() {
			var requested = [],
				loaded = [],
				callbacks = [],
				my;

			my = {
				load: function(js_file) {
					var script = this;

					return function() {
						if ("readyState" in this) {
							if (this.readyState === "loaded" || this.readyState === "complete") {
								this.onreadystatechange = null;
								loaded.push(js_file);
								my.callback.apply(script, [js_file]);
							}
						} else {
							loaded.push(js_file);
							my.callback.apply(script, [js_file]);
						}
					};
				},

				error: function(js_file, callback) {
					var script = this;

					return function() {
						requested.splice($.inArray(js_file, requested), 1);
						my.callback.apply(script, [js_file, callback]);
					};
				},

				addCallback: function(js_file, callback) {
					var index;

					if ((index = my.getCallbackIndex(js_file)) !== -1) {
						callbacks[index].callbacks.push(callback);
					} else {
						callbacks.push({
							'js_file': js_file,
							'callbacks': [callback]
						});
					}
				},

				getCallbackIndex: function(js_file) {
					var a;

					for (a = 0; a < callbacks.length; a += 1) {
						if (callbacks[a].js_file === js_file) {
							return a;
						}
					}

					return -1;
				},

				callback: function(js_file, callback) {
					var index, a;

					if (typeof callback === "function") {
						callback.apply(this, [js_file]);
					} else if ((index = my.getCallbackIndex(js_file)) !== -1) {
						for (a = 0; a < callbacks[index].callbacks.length; a += 1) {
							callbacks[index].callbacks[a].apply(this, [js_file]);
						}

						callbacks[index].callbacks = [];
					}
				}
			};

			return {
				/**
				 * Called whenever a JS file is loaded.
				 * @callback WSIncludeLoadCallback
				 * @arg {string} js_file The original included JavaScript path
				 * @this {object} Script resource for the JS file
				 */

				/**
				 * Called whenever a JS file fails to load.
				 * @callback WSIncludeLoadError
				 * @arg {string} js_file The original included JavaScript path
				 * @this {object} Script resource for the JS file
				 * @description
				 * At present, this callback will not run when a failure occurs in older versions
				 * of Internet Explorer.
				 */

				/**
				 * @function WS.Include.load
				 * @arg {string} js_file The JavaScript path to include.
				 * @arg {WSIncludeLoadCallback} [callback] Callback function, executed on load.
				 * @arg {string} [type=text/javascript] `type` attribute override.
				 */

				/**
				 * @function WS.Include.load
				 * @arg {string} js_file The JavaScript path to include.
				 * @arg {WSIncludeLoadCallback} [callback] Callback function, executed on load.
				 * @arg {WSIncludeLoadError} [error] Callback function, executed on error.
				 * @arg {string} [type=text/javascript] `type` attribute override.
				 * @description
				 * Include a JavaScript file. When loaded, will fire `callback`. If your JavaScript file is
				 * anything other than 'text/javascript', specify an optional `type`.
				 */
				load: function(js_file, callback, error, type) {
					var script;

					if (typeof error === "string") {
						// overload `error` argument to `type`
						type = error;
						error = undefined;
					}

					if ($.inArray(js_file, loaded) === -1 &&
						$.inArray(js_file, requested) === -1) {
						// not in loaded/requested array
						type = (type || "text/javascript");
						script = document.createElement("script");

						if (script.setAttribute) {
							script.setAttribute("type", type);
						}

						requested.push(js_file);
						my.addCallback(js_file, callback);

						if (typeof callback === "function") {
							if ("onreadystatechange" in script) {
								script.onreadystatechange = my.load.apply(script, [js_file]);
							} else {
								script.onload = my.load.apply(script, [js_file]);
								script.onerror = my.error.apply(script, [js_file, error]);
							}
						}

						script.src = js_file;

						document.getElementsByTagName("head")[0].appendChild(script);
					} else if ($.inArray(js_file, loaded) !== -1 &&
						typeof callback === "function") {
						// js file is loaded - immediately fire callback
						my.callback.apply(script, [js_file, callback]);
					} else {
						// js file has been requested already but not loaded - store callback
						my.addCallback(js_file, callback);
					}
				}
			};
		}()),

		/**
		 * @namespace WS.JSMedia
		 */
		JSMedia: (function() {
			var my, cls;

			cls = {
				last_query: {
					'query': null,
					'string': ''
				},

				/**
				 * @function WS.JSMedia.run
				 * @arg {Array} query An array of CSS media queries to test.
				 * @returns {boolean} Returns `true` if the query applies, `false` otherwise.
				 * @example
				 * // Runs the equivalent CSS media query:
				 * // @media only screen and (min-width: 768px)
				 * if (WS.JSMedia.run([[
				 *     'screen',
				 *     '(min-width: 768px)'
				 * ]])) {
				 *     alert("Width less than 768px");
				 * } else {
				 *     alert("Width over 768px");
				 * }
				 * @example
				 * // Multiple queries - would run the equivalent CSS media query:
				 * // @media only screen and (max-width: 1000px), projection
				 *  WS.JSMedia.run([
				 *     'screen',
				 *     '(max-width: 1000px)'
				 * ], [
				 *     'projection'
				 * ]);
				 * @description
				 * This method works in a similar way to the media queries within CSS. The User
				 * Agent is tested for compatibility with the query, and returns a result.
				 * ##### The 'only' keyword
				 * This keyword is added to avoid older browsers misinterpereting the media query
				 * and returning a false-positive result. If the browser supports `window.matchMedia`,
				 * this keyword is omitted.
				 */
				run: function(query) {
					var media_query, clauses, a, b, result;

					if (my.mqtest === undefined) {
						// create an element for css application
						my.mqtest = $("<span>", {
							'id': 'js-media-test'
						}).css({
							'display': 'none'
						});
					}

					this.last_query.query = query;

					if (typeof query === "string") {
						// one query
						media_query = query;
					} else if (query.length > 0) {
						// multiple queries (OR)
						media_query = [];

						for (a = 0; a < query.length; a += 1) {
							// each clause joined with AND
							clauses = [];

							if (typeof query[a] === "string") {
								clauses.push(query[a]);
							} else {
								for (b = 0; b < query[a].length; b += 1) {
									clauses.push(query[a][b]);
								}
							}

							media_query.push(clauses.join(" and "));
						}
					}

					if (typeof window.matchMedia === "function") {
						// use matchMedia
						result = (!!(window.matchMedia(media_query).matches));
					} else {
						// insert test element into document
						$(document.body).append(my.mqtest);

						// add 'only' keyword for legacy browsers
						media_query = "only " + media_query.join(", ");

						// inject css for test
						$("head").append(
							(my.mqcss = $("<style>", {
								'type': 'text/css',
								'media': media_query
							}))
						);

						// browser specific injection
						if (my.mqcss[0].styleSheet) {
							my.mqcss[0].styleSheet.cssText = "#js-media-test { visibility: hidden; }";
						} else if (my.mqcss[0].sheet) {
							my.mqcss[0].sheet.insertRule("#js-media-test { visibility: hidden; }", 0);
						}

						if (my.mqtest.css("visibility") === "hidden") {
							// query applies
							result = true;
						} else {
							// query does not apply
							result = false;
						}

						my.mqcss.remove();
						my.mqtest.remove();
					}

					// set last query used
					this.last_query.string = media_query;

					return result;
				},

				/**
				 * Called whenever a {@link WS.JSMedia.monitor} media change is detected
				 * @callback WSJSMediaMonitor
				 * @arg {Array} result An array of results, reflecting the boolean status of each
				 * media query.
				 * @this WS.JSMedia
				 */

				/**
				 * @function WS.JSMedia.monitor
				 * @arg {...Array} query The CSS media query(ies) to test. See {@link WS.JSMedia.run}.
				 * @arg {WSJSMediaMonitor} callback Called on media change.
				 * for details.
				 * @returns {number} The index of the added monitor rule. Used by
				 * {@link WS.JSMedia.end_monitor}.
				 * @description
				 * Monitors the user agent constantly for CSS media changes.
				 */
				monitor: function() {
					var a, queries, callback;

					if (arguments.length < 2) {
						throw new Error("Arguments must include at least one query and a callback");
					}

					queries = [];

					for (a = 0; a !== arguments.length; a += 1) {
						// get query(ies) from argument
						if (typeof arguments[a] === "function") {
							callback = arguments[a];
						} else {
							queries.push(arguments[a]);
						}
					}

					my.monitors.push({
						'queries': queries,
						'callback': callback
					});

					// run immediately
					my.exec_monitor(my.monitors.length - 1, true);

					if (my.monitors.length === 1) {
						$(window).bind("resize", my.resize);
					}

					return (my.monitors.length - 1);
				},

				/**
				 * @function WS.JSMedia.end_monitor
				 * @arg {number} index Numeric index of the monitor, as returned by
				 * {@link WS.JSMedia.monitor}.
				 * @returns {boolean} `true` on success, `false` otherwise.
				 * @description
				 * Ends a monitoring rule and removes it from memory.
				 */
				end_monitor: function(index) {
					var result;

					if (my.monitors.length > index) {
						result = !!(my.monitors.splice(index, 1));

						if (my.monitors.length === 0) {
							$(window).unbind("resize", my.resize);
						}

						return result;
					} else {
						return false;
					}
				}
			};

			my = {
				timers: {},
				monitors: [],

				resize: function() {
					if (my.timers.resize) {
						window.clearTimeout(my.timers.resize);
					}

					my.timers.resize = window.setTimeout(function() {
						my.exec_monitor();
						delete my.timers.resize;
					}.bind(this), 100);
				}.bind(cls),

				exec_monitor: function(index, initial) {
					var a, exec;

					initial = initial || false;

					exec = function(a) {
						var b, result;

						result = [];

						for (b = 0; b !== my.monitors[a].queries.length; b += 1) {
							result.push(cls.run(my.monitors[a].queries[b]));
						}

						my.monitors[a].callback.apply(
							this,
							[result, initial]
						);
					};

					if (my.monitors.length > 0) {
						if (index === undefined) {
							for (a = 0; a !== my.monitors.length; a += 1) {
								exec(a);
							}
						} else {
							exec(index);
						}
					}
				}.bind(cls)
			};

			return cls;
		}()),

		/**
		 * Permanent and temporary DOM/Cookie storage wrapper.
		 * @namespace WS.Storage
		 */
		Storage: (function() {
			var my;

			my = {
				'sets': {
					'local': (typeof window.localStorage !== "undefined"),
					'session': (typeof window.sessionStorage !== "undefined"),
					'cookie': (typeof document.cookie !== "undefined")
				},

				'cookie': {
					getItem: function(key) {
						return unescape(
							document.cookie.replace(
								new RegExp("(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
									"\\=((?:[^;](?!;))*[^;]?)(?:;.*)?|.*"),
								"$1"
							)
						) || null;
					},

					setItem: function(key, val, expires, path) {
						var cookie;

						cookie = escape(key) + "=" + escape(val);

						if (typeof expires === "string") {
							cookie += "; expires=" + expires;
						}

						cookie += "; path=" + (path || "/");

						if (WS.Storage.domain !== null) {
							cookie += "; domain=" + WS.Storage.domain;
						}

						document.cookie = cookie;
					},

					removeItem: function(key) {
						var a, b, domains, paths, path_parts, domain_parts;

						if (!key) {
							return;
						}

						domains = [""];
						paths = [""];

						domain_parts = location.hostname.split(".");
						path_parts = location.pathname.replace(/^\/(.*?)\/$/, "$1").split("/");

						// create a list of domains
						for (a = domain_parts.length - 2; a >= 0; a -= 1) {
							domains.push(
								((a > 0) ? "." : "") +
								domain_parts.slice(a, (domain_parts.length)).join(".")
							);
						}

						// create a list of paths
						for (a = 0; a <= path_parts.length; a += 1) {
							paths.push(
								"/" +
								path_parts.slice(0, a).join("/")
							);
						}

						// clear without path/domain data
						document.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;";

						if (my.cookie.getItem(key) !== null) {
							// clear with specific path/domain data
							_out:

							for (a = 0; a < domains.length; a += 1) {
								for (b = 0; b < paths.length; b += 1) {
									document.cookie = escape(key) + "=;" +
										" expires=Thu, 01 Jan 1970 00:00:00 GMT;" +
										((domains[a] !== "") ? " domain=" + domains[a] + ";" : "") +
										((paths[b] !== "") ? " path=" + paths[b] : "");

									if (my.cookie.getItem(key) === null) {
										break _out;
									}
								}
							}
						}
					}
				},

				log: function(msg) {
					if (typeof console !== "undefined" && console.log) {
						console.log(msg);
					}
				}
			};

			return {
				/**
				 * When setting values, a specific storage method can be forced. Below are the various
				 * storage methods available.
				 * @property {object} WS.Storage.types
				 * @property {number} WS.Storage.types.Session
				 * @property {number} WS.Storage.types.Local
				 * @property {number} WS.Storage.types.Cookie
				 * @memberof WS.Storage
				 */
				'types': {
					'Session': 0,
					'Local': 1,
					'Cookie': 2
				},

				/**
				 * @property {object} WS.Storage.modes
				 * @property {number} WS.Storage.modes.standard
				 * The standard storage method, which will create serialised objects. Allows for the
				 * use of expiry dates and complex data types.
				 * @property {number} WS.Storage.modes.basic
				 * The basic storage method, which stores plain strings. Useful for compatibility
				 * with server side scripts.
				 * @memberof WS.Storage
				 */
				'modes': {
					'standard': 0,
					'basic': 1
				},

				/**
				 * @property {number} WS.Storage.mode
				 * The current storage mode.
				 * @memberof WS.Storage
				 * @see WS.Storage.modes
				 */
				'mode': 0,

				/**
				 * @property {string} WS.Storage.domain
				 * The current storage domain. Applies only to {@link WS.Storage.types}.Cookie
				 * storage methods.
				 * @memberof WS.Storage
				 */
				'domain': null,

				/**
				 * @function WS.Storage.get
				 * @arg {string} key - The storage property name.
				 * @arg {*} default_val - The default value.
				 * @arg {WS.Storage.modes} mode - Override the default storage mode.
				 * @returns {*} - Either the property's value, or the contents of `default_val`.
				 * @description
				 * Retrieve a value from storage. In the case that the value does not exist or has
				 * expired. The `default_val` value is returned.
				 */
				get: function(key, default_val, mode) {
					var data, val, date, expiry_date;

					if (default_val === undefined) {
						default_val = null;
					}

					if (mode === undefined) {
						// set mode to current global mode
						mode = WS.Storage.mode;
					}

					data = null;

					if (my.sets.session) {
						// attempt retrieval from sessionStorage
						data = sessionStorage.getItem(key);
					}

					if (data === null && my.sets.local) {
						// attempt retrieval from localStorage
						data = localStorage.getItem(key);
					}

					if (data === null) {
						// value still null - attempt cookie
						data = my.cookie.getItem(key);
					}

					if (mode !==  WS.Storage.modes.standard &&
						mode !== WS.Storage.modes.basic) {
						throw new Error("Invalid/undefined storage mode specified." +
							" Mode must be one of the WS.Storage.modes items.");
					}

					// convert JSON data
					if (data !== null && mode === WS.Storage.modes.standard) {
						// attempt to parse value as JSON, otherwise create object from value
						try {
							try {
								if ((data = $.parseJSON(data))) {
									// json parsing succeeded
									if (typeof data !== "object") {
										// value is not an object
										data = {
											'val': (data.toString() || null)
										};
									}
								}
							} catch(e) {
								// JSON conversion failed - create object from value
								data = {
									'val': (data.toString() || null)
								};
							}

							if (data !== null && data.val !== null) {
								// test expiry
								if (data.expires) {
									date = new Date();
									expiry_date = new Date(data.expires);

									if (date >= expiry_date) {
										// data has expired - set null and remove
										data = null;
										this.clear(key);
									} else {
										data = data.val;
									}
								} else {
									data = data.val;
								}
							}
						} catch(e) {
							data = null;
						}
					}

					if (data === null) {
						// set as default
						val = default_val;
					} else {
						val = data;
					}

					return val;
				},

				/**
				 * @function WS.Storage.set
				 * @arg {string} key - Storage property name.
				 * @arg {string|Object|Array|boolean} data - Storage property data.
				 * @arg {*} expires - Expiry date.
				 * @arg {String} path='/' - The root path. (Used mainly by cookies).
				 * @arg {WS.Storage.types} storage - Which storage mechanism to use.
				 * @returns {number} - The {@link WS.Storage.types} method used for storage.
				 * @description
				 * ##### Setting expiry dates
				 * To store temporary data, omit the expiry date. The data will be cleared at the end of the
				 * browser session.
				 *
				 * To store expiring or explicity permanent data, an expiry date can be set using the
				 * `expires` option. This option takes one of four possible values - three of which are explained
				 * in full detail on the
				 * {@link https:// developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Date|MDC Date Documentation}.
				 *
				 * The possible values are:
				 *
				 * * `milliseconds` (`number`): Number of milliseconds since the epoch.
				 * * `dateString` (`string`): An [IETF-compliant](http:// tools.ietf.org/html/rfc1123) string representing a date.
				 * * `[YYYY, MM, DD[, HH, MM, SS, MS]]` (`Array`): An array in the form of
				 *   [year, month, day, hour, minute, second, millisecond]. The minimum required values are `year`, `month` and `day`.
				 *   The one difference between this array and that used in the `Date` Object is that the month is not zero based (i.e.
				 *   you can use `5` for May, `1` for Janurary etc).
				 * * `false` (`boolean`): Use `false` to create a permanent data item. Note: If using cookies (either by browser
				 *   limitation or specification), the cookie expiry is set to +365 days. For longer expiries, specify a date.
				 */
				set: function(key, data, expires, path, storage, mode) {
					var method, expiry_date;

					path = path || "/";

					if (!key) {
						throw new Error("A valid key is required for setting a storage item.");
					}

					data = {
						'val': data
					};

					if (mode === undefined) {
						// set mode to current global mode
						mode = WS.Storage.mode;
					}

					if (expires !== undefined && expires !== null) {
						// set expiry date
						if (expires.length && expires.length <= 6) {
							// format date with defaults
							expires = [
								expires[0] || 0,
								(!isNaN(expires[1]) ? (expires[1] - 1) : 0),
								expires[2] || 1,
								expires[3] || 0,
								expires[4] || 0,
								expires[5] || 0,
								expires[6] || 0
							];

							expiry_date = new Date(expires[0], expires[1], expires[2], expires[3], expires[4], expires[5], expires[6]);
						} else if (typeof expires === "string") {
							expiry_date = new Date(expires);
						} else if (expires === false) {
							// set expiry as 365 days
							expiry_date = new Date();
							expiry_date.setTime(expiry_date.getTime() + (365 * 24 * 60 * 60 * 1000));
						}

						if (!expiry_date.toUTCString) {
							throw new Error("Expiry date " + expires + " is in invalid format.");
						}

						if (!my.sets.local || storage === WS.Storage.types.Cookie) {
							// using a cookie
							if (data.val.length > 4000) {
								throw new Error("A maximum length of 4000 characters is allowed for using cookie-based storage.");
							}
						}
					}

					if (mode === WS.Storage.modes.standard) {
						// standard storage mode - use objects to allow for LS expiries and complex data storage
						if (expiry_date === undefined) {
							// expires at end of session
							try {
								if (my.sets.session && storage !== WS.Storage.types.Cookie) {
									method = WS.Storage.types.Session;
									sessionStorage.setItem(key, JSON.stringify(data));
								} else {
									method = WS.Storage.types.Cookie;
									my.cookie.setItem(key, JSON.stringify(data));
								}
							} catch(e) {
								my.log(e);
							}
						} else {
							// expires on a date, or never
							if (my.sets.local && storage !== WS.Storage.types.Cookie) {
								method = WS.Storage.types.Local;

								try {
									if (expires !== false) {
										data.expires = expiry_date.toUTCString();
										localStorage.setItem(key, JSON.stringify(data));
									} else {
										localStorage.setItem(key, JSON.stringify(data));
									}
								} catch(e) {
									my.log(e);
								}
							} else {
								method = WS.Storage.types.Cookie;
								my.cookie.setItem(key, JSON.stringify(data), expiry_date.toUTCString(), path);
							}
						}
					} else if (mode === WS.Storage.modes.basic) {
						// basic storage mode - only set a string value
						if (data.val !== undefined) {
							data.val = (data.val.toString() || "");
						}

						if (expiry_date === undefined) {
							// expires at end of session
							try {
								if (my.sets.session && storage !== WS.Storage.types.Cookie) {
									method = WS.Storage.types.Session;
									sessionStorage.setItem(key, data.val);
								} else {
									method = WS.Storage.types.Cookie;
									my.cookie.setItem(key, data.val);
								}
							} catch(e) {
								my.log(e);
							}
						} else {
							// expires on a date, or never
							if (my.sets.local && storage !== WS.Storage.types.Cookie) {
								method = WS.Storage.types.Local;

								if (expires !== false) {
									// cookie must be used for dated expiry in basic mode
									method = WS.Storage.types.Cookie;
									my.cookie.setItem(key, data.val, expiry_date.toUTCString(), path);
								} else {
									try {
										localStorage.setItem(key, data.val);
									} catch(e) {
										my.log(e);
									}
								}
							} else {
								method = WS.Storage.types.Cookie;
								my.cookie.setItem(key, data.val, expiry_date.toUTCString(), path);
							}
						}
					} else {
						throw new Error("Invalid/undefined storage mode specified." +
							" Mode must be one of the WS.Storage.modes items.");
					}

					return method;
				},

				/**
				 * @function WS.Storage.clear
				 * @arg {string} key Storage property name to clear.
				 * @description
				 * Clear a value from storage. Will attempt to clear the value from all storage
				 * containers, regardless of the method used when setting.
				 */
				clear: function(key) {
					if (my.sets.session) {
						// attempt removal from sessionStorage
						sessionStorage.removeItem(key);
					}

					if (my.sets.local) {
						// attempt removal from localStorage
						localStorage.removeItem(key);
					}

					if (my.sets.cookie) {
						// attempt removal from cookie
						my.cookie.removeItem(key);
					}
				}
			};
		}())
	};
}(window.jQuery));

(function($) {
	/*
	 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
	 *
	 * Uses the built in easing capabilities added In jQuery 1.1
	 * to offer multiple easing options
	 *
	 * TERMS OF USE - jQuery Easing
	 *
	 * Open source under the BSD License.
	 *
	 * Copyright © 2008 George McGinley Smith
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *
	 * Redistributions of source code must retain the above copyright notice, this list of
	 * conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list
	 * of conditions and the following disclaimer in the documentation and/or other materials
	 * provided with the distribution.
	 *
	 * Neither the name of the author nor the names of contributors may be used to endorse
	 * or promote products derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
	 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
	 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
	 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
	 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
	 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
	 * OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	*/

	// t: current time, b: begInnIng value, c: change In value, d: duration
	$.easing['jswing'] = $.easing['swing'];

	$.extend($.easing, {
		def: 'easeOutQuad',
		swing: function (x, t, b, c, d) {
			//alert($.easing.default);
			return $.easing[$.easing.def](x, t, b, c, d);
		},
		easeInQuad: function (x, t, b, c, d) {
			return c*(t/=d)*t + b;
		},
		easeOutQuad: function (x, t, b, c, d) {
			return -c *(t/=d)*(t-2) + b;
		},
		easeInOutQuad: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t + b;
			return -c/2 * ((--t)*(t-2) - 1) + b;
		},
		easeInCubic: function (x, t, b, c, d) {
			return c*(t/=d)*t*t + b;
		},
		easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
		easeInOutCubic: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t + b;
			return c/2*((t-=2)*t*t + 2) + b;
		},
		easeInQuart: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t + b;
		},
		easeOutQuart: function (x, t, b, c, d) {
			return -c * ((t=t/d-1)*t*t*t - 1) + b;
		},
		easeInOutQuart: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
			return -c/2 * ((t-=2)*t*t*t - 2) + b;
		},
		easeInQuint: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t*t + b;
		},
		easeOutQuint: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t*t*t + 1) + b;
		},
		easeInOutQuint: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
			return c/2*((t-=2)*t*t*t*t + 2) + b;
		},
		easeInSine: function (x, t, b, c, d) {
			return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
		},
		easeOutSine: function (x, t, b, c, d) {
			return c * Math.sin(t/d * (Math.PI/2)) + b;
		},
		easeInOutSine: function (x, t, b, c, d) {
			return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
		},
		easeInExpo: function (x, t, b, c, d) {
			return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
		},
		easeOutExpo: function (x, t, b, c, d) {
			return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInOutExpo: function (x, t, b, c, d) {
			if (t==0) return b;
			if (t==d) return b+c;
			if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
			return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
		},
		easeInCirc: function (x, t, b, c, d) {
			return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
		},
		easeOutCirc: function (x, t, b, c, d) {
			return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
		},
		easeInOutCirc: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
			return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
		},
		easeInElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		},
		easeInOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
			return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
		},
		easeInBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*(t/=d)*t*((s+1)*t - s) + b;
		},
		easeOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
		},
		easeInOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
			return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
		},
		easeInBounce: function (x, t, b, c, d) {
			return c - $.easing.easeOutBounce (x, d-t, 0, c, d) + b;
		},
		easeOutBounce: function (x, t, b, c, d) {
			if ((t/=d) < (1/2.75)) {
				return c*(7.5625*t*t) + b;
			} else if (t < (2/2.75)) {
				return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
			} else if (t < (2.5/2.75)) {
				return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
			} else {
				return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
			}
		},
		easeInOutBounce: function (x, t, b, c, d) {
			if (t < d/2) return $.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
			return $.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
		}
	});
}(window.jQuery));

/**
 * @class Promise
 * @description
 * This is a Polyfill for the built in Promise Object that many modern browsers now support
 * natively.
 * @see https://github.com/taylorhakes/promise-polyfill
 * @version 2.1.0
 **/
!function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void j(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"==typeof a?a:null,this.onRejected="function"==typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j="function"==typeof setImmediate&&setImmediate||function(a){setTimeout(a,1)},k=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&k(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"==typeof g||"function"==typeof g)){var h=g.then;if("function"==typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"==typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){j=a},"undefined"!=typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);